export const isEnum = <T extends Record<string, string>>(
	value: string | undefined,
	compare: T
): value is T[keyof T] =>
	value ? Object.values(compare).includes(value) : false;
